/* eslint-disable react/jsx-no-bind */
import { Button, CircularProgress, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, Typography, Grid } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ClearIcon from '@material-ui/icons/Clear';
import TableChartOutlinedIcon from '@material-ui/icons/TableChartOutlined';
import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import { rdsSelect } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toPercent } from '../../modules/text';


function CountyComparisonTableHome() {
  const { stateCode } = useParams();
  const {
    primaryColor
  } = useContext(StoryContext);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState('');
  const [selectedCounties, setSelectedCounties] = useState([]);


  useEffect(() => {
    function getCountyData() {
      const whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND (county_suppressed=0 OR county_suppressed=NULL)`;
      return rdsSelect('3rdparty', 'acs_sams_county_wide', {
        cols: 'county_fips,prop_struct_before_1980b',
        where: whereClause,
        format: 'amcharts',
        inject: true,
        orderby: 'county_fips',
        limit: 500,
      });
    }

    function getStateData() {
      const whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      return rdsSelect('3rdparty', 'acs_sams_state_wide', {
        cols: 'state_fips,prop_struct_before_1980b',
        where: whereClause,
        format: 'amcharts',
        inject: false,
        orderby: 'state_fips',
        limit: 500,
      });
    }
    Promise.all([getCountyData(), getStateData()])
      .then((results) => {
        const d = results[0].parsedBody.dataProvider;
        const sd = results[1].parsedBody.dataProvider[0];
        const payload = d.map((v) => Object.assign(v, { value: v.prop_struct_before_1980b }));
        setData(payload);
        setStateData(sd);
      })
      .catch((rdsError) => {
        setError(rdsError);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  const handleSelectionChange = (event) => {
    setSelectedCounty(event.target.value);
  };

  const handleAddCounty = () => {
    if (!_.includes(selectedCounties, selectedCounty)) {
      setSelectedCounties(selectedCounties.concat([selectedCounty]));
    }
    setSelectedCounty('');
  };

  const removeCounty = (c) => (e) => {
    if (!c) return;
    setSelectedCounties(selectedCounties.filter((f) => (f.county_fips !== c.county_fips)));
  };

  if (!ready) {
    return <CircularProgress />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        color: primaryColor,
      }}
      >
        <TableChartOutlinedIcon />&nbsp;<Typography variant="h5">County Comparison Table</Typography>
      </div>
      <Grid container>
        <Grid item xs={8} sm={6} lg={3}>
          <FormControl>
            <InputLabel id="countySelect">County</InputLabel>
            <Select
              labelId="countySelect"
              id="countySelectHelper"
              value={selectedCounty}
              onChange={handleSelectionChange}
            >
              {data.map((d) => (<MenuItem value={d} key={d.county_fips}>{d.county_fips}</MenuItem>))}

            </Select>
            <FormHelperText>Select a county from the menu to add to the comparison table</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={4} sm={6} lg={9}>
          <Button
            disabled={!selectedCounty}
            variant="contained"
            onClick={handleAddCounty}
            style={{
              marginLeft: '20px', marginBottom: '-70px', backgroundColor: primaryColor, color: '#fff',
            }}
            size="small"
          >Add to table
          </Button>
        </Grid>
      </Grid>
      <Table size="small" aria-label="County comparison table" style={{ overflowX: 'auto', display: 'block' }}>
        <TableHead>
          <TableRow>
            <TableCell><Typography variant="body2">County</Typography></TableCell>
            <TableCell align="right">
              <Typography variant="body2">
                Percent of children that live in homes built before 1979
              </Typography>
            </TableCell>

            <TableCell>&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow selected>
            <TableCell component="th" scope="row">
              {states[stateCode.toUpperCase()]} (State)
            </TableCell>
            <TableCell align="right">{toPercent(stateData.prop_struct_before_1980b)}</TableCell>
            <TableCell>&nbsp;</TableCell>
          </TableRow>
          {selectedCounties.map((row) => (
            <TableRow key={row.county_fips}>
              <TableCell component="th" scope="row">
                {row.county_fips}
              </TableCell>
              <TableCell align="right">{row.value ? toPercent(row.value) : 'No Data'}</TableCell>
              <TableCell><IconButton size="small" onClick={removeCounty(row)} aria-label={`Remove ${row.county_fips}`}><ClearIcon /></IconButton></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}

export default CountyComparisonTableHome;
